<template>
  <b-modal
    centered
    title="Delete Custom Dashboard"
    @ok="deleteDashboard"
    ref="modal"
  >
    Are you sure you want to delete custom dashboard "{{ name }}"?
    All associated panels will also be deleted.
    You cannot undo this action.
  </b-modal>
</template>

<script>
import DashboardEventBus from '@/xvisor/bus/DashboardEventBus';

export default {
  props: {
    url: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
  },
  methods: {
    deleteDashboard() {
      this.$http
        .delete(this.url)
        .then(() => {
          this.$bvToast.toast('Successfully deleted dashboard', { variant: 'success' });
          DashboardEventBus.$emit('deleted');
        })
        .catch(() => {
          this.$bvToast.toast('Failed to delete dashboard', { variant: 'danger' });
        });
    },
  },
};
</script>
